import { ERROR, LOADING, LOADING_DETAILS, SUCCESS, SUCCESS_DETAILS } from './ThroughputHistogramActions';

const INITIAL_STATE = {
  isLoading: true,
  detailsIsLoading: true,
  success: false,
  error: '',
  data: [],
  details: [],
};

const ThroughputHistogramReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case LOADING_DETAILS: {
      return { ...state, detailsIsLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: action.data };
    }
    case SUCCESS_DETAILS: {
      return { ...state, detailsIsLoading: false, details: action.data };
    }
    default:
      return state;
  }
};

export default ThroughputHistogramReducer;
